import {
    AdminValidation,
    AgentInvoiceValidation,
    AgentPaymentValidation,
    AgentSettlementValidation,
    AgentSubscriptionValidation,
    APIKeyValidation,
    AssociateAgentValidation,
    AssociateLegalsValidation,
    AssociateMarketingValidation,
    AssociatePresenceValidation,
    AssociateRegistrationValidation,
    AssociateSettingsValidation,
    AssociateUserValidation,
    AssociateValidation,
    AssociateWagentValidation,
    AuditorValidation,
    AuditProductInternetValidation,
    AuditSubscriptionValidation,
    CustomerComplaintValidation,
    CustomerImportValidation,
    CustomerInvoiceValidation,
    CustomerRegistrationValidation,
    CustomerValidation,
    DebugToolsValidation,
    DevToolsValidation,
    FeatureTogglesValidation,
    FinanceAccountValidation,
    FinanceDisbursementAccountValidation,
    FinanceDisbursementValidation,
    FinanceInvoiceValidation,
    FinancePaymentValidation,
    FinanceReportValidation,
    FinanceTaxValidation,
    HotspotSessionValidation,
    HotspotTemplateValidation,
    HotspotVoucherValidation,
    LegalsValidation,
    MarketingDisbursementValidation,
    MarketingInvoiceValidation,
    MarketingSubscriptionValidation,
    NetworkGroupValidation,
    NetworkOLTValidation,
    NetworkONTBlockValidation,
    NetworkONTValidation,
    NetworkPOPValidation,
    NetworkUsageValidation,
    NotificationValidation,
    PrivilegeValidation,
    ProductBroadbandValidation,
    ProductDedicatedValidation,
    ProductHotspotValidation,
    ProvisionReturnValidation,
    ProvisionValidation,
    RadiusAccountValidation,
    RadiusNASValidation,
    RadiusServerValidation,
    RadiusSessionValidation,
    ResellerInvoiceValidation,
    ResellerRegistrationValidation,
    ResellerValidation,
    SettingsValidation,
    SkipAuditSubscriptionValidation,
    SubscriptionDismantleValidation,
    SubscriptionProductChangeValidation,
    SubscriptionValidation,
    SystemDisbursementValidation,
    UserValidation,
    WarehouseItemTypeValidation,
    WarehouseItemValidation,
    WarehouseLocationValidation,
    WhatsAppInvoiceValidation,
    WhatsAppMessageValidation,
    WhatsAppUsageValidation,
} from "backend";

export namespace Requests {
    export const Admin = AdminValidation;
    export const AgentInvoice = AgentInvoiceValidation;
    export const AgentPayment = AgentPaymentValidation;
    export const AgentSettlement = AgentSettlementValidation;
    export const AgentSubscription = AgentSubscriptionValidation;
    export const APIKey = APIKeyValidation;
    export const Associate = AssociateValidation;
    export const AssociateAgent = AssociateAgentValidation;
    export const AssociateLegals = AssociateLegalsValidation;
    export const AssociateMarketing = AssociateMarketingValidation;
    export const AssociatePresence = AssociatePresenceValidation;
    export const AssociateRegistration = AssociateRegistrationValidation;
    export const AssociateSettings = AssociateSettingsValidation;
    export const AssociateUser = AssociateUserValidation;
    export const AssociateWagent = AssociateWagentValidation;
    export const Auditor = AuditorValidation;
    export const AuditProductInternet = AuditProductInternetValidation;
    export const AuditSubscription = AuditSubscriptionValidation;
    export const Customer = CustomerValidation;
    export const CustomerComplaint = CustomerComplaintValidation;
    export const CustomerImport = CustomerImportValidation;
    export const CustomerInvoice = CustomerInvoiceValidation;
    export const CustomerRegistration = CustomerRegistrationValidation;
    export const DebugTools = DebugToolsValidation;
    export const DevTools = DevToolsValidation;
    export const FeatureToggles = FeatureTogglesValidation;
    export const FinanceAccount = FinanceAccountValidation;
    export const FinanceDisbursement = FinanceDisbursementValidation;
    export const FinanceDisbursementAccount = FinanceDisbursementAccountValidation;
    export const FinanceInvoice = FinanceInvoiceValidation;
    export const FinancePayment = FinancePaymentValidation;
    export const FinanceReport = FinanceReportValidation;
    export const FinanceTax = FinanceTaxValidation;
    export const HotspotSession = HotspotSessionValidation;
    export const HotspotTemplate = HotspotTemplateValidation;
    export const HotspotVoucher = HotspotVoucherValidation;
    export const Legals = LegalsValidation;
    export const MarketingDisbursement = MarketingDisbursementValidation;
    export const MarketingInvoice = MarketingInvoiceValidation;
    export const MarketingSubscription = MarketingSubscriptionValidation;
    export const NetworkGroup = NetworkGroupValidation;
    export const NetworkOLT = NetworkOLTValidation;
    export const NetworkONT = NetworkONTValidation;
    export const NetworkONTBlock = NetworkONTBlockValidation;
    export const NetworkPOP = NetworkPOPValidation;
    export const NetworkUsage = NetworkUsageValidation;
    export const Notification = NotificationValidation;
    export const Privilege = PrivilegeValidation;
    export const ProductBroadband = ProductBroadbandValidation;
    export const ProductDedicated = ProductDedicatedValidation;
    export const ProductHotspot = ProductHotspotValidation;
    export const Provision = ProvisionValidation;
    export const ProvisionReturn = ProvisionReturnValidation;
    export const RadiusAccount = RadiusAccountValidation;
    export const RadiusNAS = RadiusNASValidation;
    export const RadiusServer = RadiusServerValidation;
    export const RadiusSession = RadiusSessionValidation;
    export const Reseller = ResellerValidation;
    export const ResellerInvoice = ResellerInvoiceValidation;
    export const ResellerRegistration = ResellerRegistrationValidation;
    export const Settings = SettingsValidation;
    export const SkipAuditSubscription = SkipAuditSubscriptionValidation;
    export const Subscription = SubscriptionValidation;
    export const SubscriptionDismantle = SubscriptionDismantleValidation;
    export const SubscriptionProductChange = SubscriptionProductChangeValidation;
    export const SystemDisbursement = SystemDisbursementValidation;
    export const User = UserValidation;
    export const WarehouseItem = WarehouseItemValidation;
    export const WarehouseItemType = WarehouseItemTypeValidation;
    export const WarehouseLocation = WarehouseLocationValidation;
    export const WhatsAppInvoice = WhatsAppInvoiceValidation;
    export const WhatsAppMessage = WhatsAppMessageValidation;
    export const WhatsAppUsage = WhatsAppUsageValidation;
}
